module.exports = __webpack_public_path__ + "img/26400.ac6fea28.jpg";